import SwiperTopOverlayComponent from "./SwiperTopOverlayComponent";

export default SwiperTopOverlayComponent;